import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Wrench, Settings, RefreshCw, Replace, PlayCircle, HandshakeIcon, Handshake } from "lucide-react";

const ICONS = [Wrench, Settings, RefreshCw, Replace, PlayCircle, Handshake];

export default function Services() {
  const { t } = useLanguage();

  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-24 bg-[#e8ecf3]">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-8 mb-12">
          <div className="col-span-12 md:col-span-4">
            <div className="font-mono-tech text-[#1d428a] mb-6">
              <span className="inline-block w-2 h-2 bg-[#df4661] mr-3 align-middle" />
              {t.services.eyebrow}
            </div>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 data-testid="services-title" className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0A0A0A]">
              {t.services.title}
            </h2>
            <p className="mt-5 text-[#0A0A0A] text-sm md:text-base max-w-2xl leading-relaxed">
              {t.services.lead}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#1d428a]/15 bg-white">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={item.code}
                data-testid={`service-card-${i}`}
                className="group relative border-r border-b border-[#1d428a]/15 p-8 lg:p-10 hover:bg-[#1d428a] hover:text-white transition-colors duration-500 cursor-default"
              >
                <div className="flex items-start justify-between mb-10">
                  <span className="font-mono-tech text-[#df4661] group-hover:text-[#df4661]">
                    {item.code}
                  </span>
                  <Icon
                    size={26}
                    strokeWidth={1.4}
                    className="text-[#1d428a] group-hover:text-[#df4661] transition-colors"
                  />
                </div>
                <h3 className="font-display text-2xl md:text-3xl mb-3">{item.name}</h3>
                <p className="text-[#5A6270] group-hover:text-white/75 text-sm leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-6 h-px bg-[#1d428a]/15 group-hover:bg-white/20 transition-colors" />
                <div className="flex items-center justify-between mt-3 font-mono-tech">
                  <span className="text-[#5A6270] group-hover:text-white/60">CH · DE · INT.</span>
                  <span className="text-[#1d428a] group-hover:text-[#df4661]">→</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
